export var createTabsDriver = function (wrapper) {
    var base = wrapper.$(".tabs");
    return {
        getTabTexts: function () { return base.$$('.tab').text(); },
        getSelected: function () { return base.$('.selected').text(); },
        getSelectedKey: function () { return base.$('.selected').attr('data-value'); },
        getSelectedIdx: function () { return base.$$('.tab').map(function (item) {
            return item.hasClass('selected');
        }).then(function (list) { return list.indexOf(true); }); },
        selectTab: function (idx) { return base.$$('.tab').get(idx).click(); },
        isTabDisabled: function (idx) { return base.$$('.tab').get(idx).hasClass('disabled'); },
    };
};
//# sourceMappingURL=driver.js.map